import videojs from 'video.js';

class AmbientVideoModule {
    constructor(selector) {
        this.selector = selector;
        this.ambientVideos = document.querySelectorAll(selector);
        this.initAmbientVideo();
        window.addEventListener('resize', this.initAmbientVideo.bind(this));
    }

    initAmbientVideo() {
        this.ambientVideos.forEach(ambientVideo => {
            if (ambientVideo && !ambientVideo.player) {
                let player = videojs(ambientVideo, {
                    modalDialogs: false,
                    textTrackSettings: false,
                    errorDisplay: false
                });
                ambientVideo.player = player;
                this.updateVideo(player, ambientVideo);
            }
        });
    }

    updateVideo(player, heroVideoElement) {
        const largeSourceElement = heroVideoElement.querySelector('[data-large-source]');
        const mediumSourceElement = heroVideoElement.querySelector('[data-medium-source]');
        const smallSourceElement = heroVideoElement.querySelector('[data-small-source]');

        const largeSource = largeSourceElement ? largeSourceElement.getAttribute('src') : '';
        const mediumSource = mediumSourceElement ? mediumSourceElement.getAttribute('src') : '';
        const smallSource = smallSourceElement ? smallSourceElement.getAttribute('src') : '';

        const screenWidth = window.innerWidth;

        let sourceURL = '';

        if (screenWidth <= 480) {
            sourceURL = smallSource;
        } else if (screenWidth <= 769) {
            sourceURL = mediumSource;
        } else {
            sourceURL = largeSource;
        }

        if (sourceURL) {
            player.src({ type: 'video/mp4', src: sourceURL });
        } else {
            console.error('Video source URL not found.');
        }
    }
}

export default AmbientVideoModule;
